var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFileFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_531382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.225 0C2.345 0 1.633 0.72 1.633 1.6L1.625 14.4C1.625 15.28 2.337 16 3.217 16H12.825C13.705 16 14.425 15.28 14.425 14.4V4.8L9.625 0H3.225ZM8.825 5.6V1.2L13.225 5.6H8.825Z",
    fill: "#8D466D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_531382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileFormat);
export default __webpack_public_path__ + "static/media/DownloadFileFormat.b36e4742ecee897c288c0ddb36663871.svg";
export { ForwardRef as ReactComponent };